module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vbl-upload"
  }, [(_vm.dataValue.length) ? _c('ul', _vm._l((_vm.dataValue), function(file) {
    return _c('li', {
      key: file.name
    }, [_vm._v("\n            " + _vm._s(file.name) + "\n        ")])
  })) : _vm._e(), _c('a', {
    staticClass: "a-upload",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('input', {
    attrs: {
      "type": "file",
      "accept": _vm.accept,
      "multiple": _vm.multiple
    },
    on: {
      "change": _vm.change
    }
  }), _c('vbl-button', {
    attrs: {
      "icon": "ion-ios-cloud-upload-outline",
      "theme": "light-secondary"
    }
  }, [_vm._t("default")], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ce36892e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblUpload/src/vblUpload.vue
// module id = 293
// module chunks = 0